import React, { useState, forwardRef, useRef } from 'react';
import EventPartner from '../../EventPartner/EventPartner';
import CommunityImg from '../CommunityImg/CommunityImg';
import useIndustryExpertsPartner from '../../hooks/useIndustryExpertsPartner';
import Filter from '../Filter/Filter';
import { default as filterIcon } from '../../../images/filterIcon.svg';
import { default as sortIcon } from '../../../images/sortIcon.svg';
// import { default as rightArrow } from '../../../../images/left-arrow.svg';
import './PartnerList.scss';

const PartnerList = forwardRef(({
  isCreativePartnerPage = false,
  limit = 12,
  isIndustryExperts = false,
  cls,
  searchTitle = "search our creatives..."
}, ref) => {

  const data = useIndustryExpertsPartner();
  
  const {
    eventPartners: { nodes: eventPartners },
    eventPartnersCountry: { distinct: partnersCountry },
    eventPartnerSpeciality: { distinct: partnerSpeciality },
    designStyle : {distinct : designStyle}
  } = data;

  // const selectRef = useRef(null);
  const tempPartnerSpeciality = [
    'Customer Experience',
    'Finance',
    'Logistics',
    'Marketing',
    'Marketplace',
    'Sourcing',
    'Sustainability',
    'Fulfillment'
    ]
  const eventPartnerListRef = useRef(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [eventPartnerList, setEventPartnerList] = useState(eventPartners || []);
  const [partnerListLimit, setPartnerListLimit] = useState(limit);
  const [searchTerm, setSearchTerm] = useState('');
  const [partnerCountry, setPartnerCountry] = useState('All');
  const [partnerSpec, setPartnerSpec] = useState('All');
  const [partnerStyle, setPartnerStyle] = useState('All');

  const filterEventPartner = str => {
    if (str.length > 3) {
      const val = str.toLowerCase();

      const filterArr = eventPartners.filter(partner => {
        const { partnerDescription: { partnerDescription }, partnerName, } = partner
        const descriptionIndex = partnerDescription.toLowerCase().includes(val);
        const partnerNameIndex = partnerName.toLowerCase().includes(val);
        if (descriptionIndex || partnerNameIndex) {
          return partner;
        }
        return false;
      });
      setEventPartnerList(filterArr);
    } else {
      const limEventPartners = !isCreativePartnerPage ? [...eventPartners].splice(0, 12) : eventPartners;
      setEventPartnerList(limEventPartners);
    }
  }

  const onSearchEventPartner = e => {
    const { target: { value } } = e;
    setSearchTerm(value);
    filterEventPartner(value);
  }

  const onEventPartnerSpecialityFilter = (e) => {
    const value = e;
    setSearchTerm('');
    setPartnerSpec(value);
    getFilteredData({ type: 'partnerSpec', value });
  }

  const onEventPartnerCountryFilter = (e) => {
    const value = e;
    setSearchTerm('');
    setPartnerCountry(value);
    getFilteredData({ type: 'partnerCountry', value });
  }

  const onEventPartnerStyleFilter = (e) => {
    const value = e;
    setSearchTerm('');
    setPartnerStyle(value);
    getFilteredData({ type: 'designStyle', value });
  }

  const getFilteredData = data => {
    const { type, value } = data;
    const tempEventPartners = eventPartners
      .filter(item => {
        const tempVal = type === 'partnerSpec' ? value : partnerSpec;
        return tempVal !== 'All' ? item?.partnerSpeciality?.some(i => i === tempVal) : item;
      }).filter(item => {
        const tempVal = type === 'partnerCountry' ? value : partnerCountry;
        return tempVal !== 'All' ? item?.partnerCountry === tempVal : item;
      }).filter(item => {
        const tempVal = type === 'designStyle' ? value : partnerStyle;
        return tempVal !== 'All' ? item?.communityProfileLink?.some(i => i?.designStyle?.some(inner => inner === value)) : item;
      });
    setEventPartnerList(tempEventPartners);
  }

  const onSort = (e) => {
    const value = e;
    if (value === 'A - Z') {
      eventPartnerList.sort((a, b) => a.partnerName.localeCompare(b.partnerName));
      setEventPartnerList([...eventPartnerList]);
    } else if (value === 'Z - A') {
      eventPartnerList.sort((a, b) => a.partnerName.localeCompare(b.partnerName)).reverse();
      setEventPartnerList([...eventPartnerList]);
    }
  }


  // const scrollTo = (value) => {
  //   eventPartnerListRef.current.scrollLeft -= value;
  // }

  return (
    <div className={`creative-list-container ${isCreativePartnerPage && 'all-event-partner-page'} ${cls}`} ref={ref}>
      {/* <div className="creative-list-heading">Our Partners</div> */}
      <div className={`creative-list-filters-buttons ${!isFilterOpen && 'filters-button-closed'}`}>
        <div className="creative-list-filters-buttons-left">
          <button className={`btn ${isFilterOpen && 'filter-open'}`} onClick={() => setIsFilterOpen(!isFilterOpen)}>
            <CommunityImg src={filterIcon} alt="filter-button" />
            <span>Filter By</span>
          </button>
          <button className="btn" >
            <CommunityImg src={sortIcon} alt="sort-button" />
            {/* eslint-disable-next-line jsx-a11y/no-onchange*/}
            {/* <select ref={selectRef} onChange={onSort}>
              <option value="0">Sort By</option>
              <option value="3">A - Z</option>
              <option value="4">Z - A</option>
            </select> */}
            <Filter
              cls='creative-list-filters-sort-by'
              filterType="eventDate"
              defaultSelection = "Sort By"
              alwaysShowDefaultSelection={true}
              width={380}
              filterData={['A - Z', 'Z - A']}
              onSelect={onSort}
            />
          </button>
        </div>
        <div className="creative-list-filters-buttons-right">
          <input
            value={searchTerm}
            type="text" id="fname"
            name="fname"
            placeholder={searchTitle}
            onChange={onSearchEventPartner}
          />
        </div>
      </div>
      {
        isFilterOpen &&
        <div className={`creative-list-filters ${isFilterOpen ? 'open' : ''}`}>
          <Filter
            cls='creative-list-filter'
            filterType="eventDate"
            title="Speciality"
            width={330}
            filterData={['All', ...tempPartnerSpeciality]}
            onSelect={onEventPartnerSpecialityFilter}
          />
          <Filter
            cls='creative-list-filter'
            filterType="eventType"
            title="Location"
            width={330}
            filterData={['All', ...partnersCountry]}
            onSelect={onEventPartnerCountryFilter}
          />
          <Filter
            cls='creative-list-filter'
            filterType="eventType"
            title="Type"
            width={330}
            filterData={['All', 'Consultant', 'Agency', 'Enterprise']}
            onSelect={onEventPartnerStyleFilter}
          />
        </div>
      }
      <div className={`creative-list-list ${isCreativePartnerPage && 'all-creative-partner-list'}`} ref={eventPartnerListRef}>
        {
          eventPartners.length ?
            [...eventPartnerList]
            .splice(0, partnerListLimit)
            .map((partnerProfile, idx) => {
              return <EventPartner
                key={`partner-${idx}`}
                eventPartner={partnerProfile}
                isAllEventPartners={isCreativePartnerPage}
                isCreativeCommunity={true}
                isIndustryExperts={isIndustryExperts}
              />
            })
            :
            <div className="no-result-found">
              Oops! We couldn’t find any results for "<span>{searchTerm}</span> ".
          </div>
        }
      </div>
        {
          eventPartnerList.length > 0 && !isCreativePartnerPage &&  eventPartnerList.length > partnerListLimit && 
          <div className="creative-list-seemore-button">
            <button onClick={()=>setPartnerListLimit(partnerListLimit + 12)}>  
              See More
            </button>
          </div>
        }
    </div>
  )
})

export default PartnerList;